var exports = {
  "n": "xfd349460--b7a009--row",
};

module.exports = exports;
